import { db } from "@/firebaseConfig";

const printersCollection = db.collection("printers");

const savePrinter = async data => {
  printersCollection
    .doc()
    .set(data)
    .then(() => {
      console.log("Printer successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const updatePrinter = async (id, data) => {
  printersCollection
    .doc(id)
    .update(data)
    .then(() => {
      console.log("Printer successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const deletePrinter = async id => {
  printersCollection
    .doc(id)
    .delete()
    .then(() => {
      console.log("Printer successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const getPrinterById = async id => {
  return printersCollection
    .doc(id)
    .get()
    .then(doc => {
      return doc.exists ? doc.data() : null;
    })
    .catch(error => {
      throw error;
    });
};

export {
  printersCollection,
  savePrinter,
  updatePrinter,
  deletePrinter,
  getPrinterById
};
